var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const Svg404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "998px",
  height: "395px",
  viewBox: "0 0 998 395",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "8.90041913%",
  y1: "57.8685803%",
  x2: "182.688942%",
  y2: "18.3256976%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F6F8",
  stopOpacity: 0.5,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAEDED",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "8.90041913%",
  y1: "58.6730785%",
  x2: "236.458431%",
  y2: "0.964035043%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F6F8",
  stopOpacity: 0.5,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAEDED",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "8.90041913%",
  y1: "58.3810597%",
  x2: "251.268202%",
  y2: "-9.81847708%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F6F8",
  stopOpacity: 0.5,
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAEDED",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.7776579%",
  y1: "50.070715%",
  x2: "50.2215488%",
  y2: "49.933714%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.9762169%",
  y1: "50.0318863%",
  x2: "50.0235747%",
  y2: "49.9734209%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.1068594%",
  y1: "99.9971255%",
  x2: "49.9012442%",
  y2: "-0.0724169243%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.3562258%",
  y1: "50.9280832%",
  x2: "50.6464164%",
  y2: "49.0311771%",
  id: "g"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.0030423%",
  x2: "100%",
  y2: "50.0030423%",
  id: "h"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "49.9940765%",
  x2: "100%",
  y2: "49.9940765%",
  id: "i"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.3558852%",
  y1: "50.9119271%",
  x2: "50.6460757%",
  y2: "49.015021%",
  id: "j"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.437169%",
  y1: "49.5803232%",
  x2: "50.5595737%",
  y2: "50.4489856%",
  id: "k"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "l"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "99.9388005%",
  y2: "50%",
  id: "m"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "41.1522737%",
  y1: "95.4918534%",
  x2: "56.6234933%",
  y2: "-1.94663951%",
  id: "n"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "46.6946951%",
  y1: "42.4420637%",
  x2: "50.6161699%",
  y2: "45.8346162%",
  id: "o"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "88.8888889%",
  y1: "49.5098875%",
  x2: "87.2581197%",
  y2: "46.1145423%",
  id: "p"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "55.7507395%",
  y1: "95.7198486%",
  x2: "52.9360516%",
  y2: "-4.5246079%",
  id: "q"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "47.7161812%",
  y1: "58.3323402%",
  x2: "49.0830322%",
  y2: "57.6064464%",
  id: "r"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "46.9054531%",
  y1: "54.9973409%",
  x2: "60.2115777%",
  y2: "46.6068073%",
  id: "s"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "39.0224947%",
  y1: "58.7133059%",
  x2: "59.9504585%",
  y2: "45.0697874%",
  id: "t"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "38.0485928%",
  y1: "56.561979%",
  x2: "55.7120517%",
  y2: "45.5085176%",
  id: "u"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "45.8613502%",
  y1: "51.4073579%",
  x2: "54.5806703%",
  y2: "46.8243079%",
  id: "v"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "20.5763959%",
  y1: "30.4428602%",
  x2: "64.8134518%",
  y2: "73.9554866%",
  id: "w"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "42.172569%",
  y1: "47.2518908%",
  x2: "79.5717287%",
  y2: "82.1895264%",
  id: "x"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "46.0891834%",
  y1: "56.3280481%",
  x2: "69.8555576%",
  y2: "84.7304538%",
  id: "y"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "26.4419858%",
  y1: "-9.18195934%",
  x2: "81.6384856%",
  y2: "105.738349%",
  id: "z"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "43.5693428%",
  y1: "50.5089463%",
  x2: "52.7565159%",
  y2: "45.7852883%",
  id: "A"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "36.2134963%",
  y1: "49.1762963%",
  x2: "69.1139111%",
  y2: "39.4296296%",
  id: "B"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "14.6653561%",
  y1: "46.53076%",
  x2: "53.5752523%",
  y2: "35.9131484%",
  id: "C"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.7775767%",
  y1: "50.0769571%",
  x2: "50.2214676%",
  y2: "49.9399561%",
  id: "D"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.9761966%",
  y1: "50.0381284%",
  x2: "50.0235544%",
  y2: "49.979663%",
  id: "E"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.1076352%",
  y1: "99.9903243%",
  x2: "49.90202%",
  y2: "-0.0792181582%",
  id: "F"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.3560679%",
  y1: "50.9128817%",
  x2: "50.6462585%",
  y2: "49.0159756%",
  id: "G"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100.040535%",
  y1: "49.9969577%",
  x2: "-4.60830311e-13%",
  y2: "49.9969577%",
  id: "H"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100.048054%",
  y1: "50.0059235%",
  x2: "0.0480538203%",
  y2: "50.0059235%",
  id: "I"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.4363386%",
  y1: "49.5926713%",
  x2: "50.5587433%",
  y2: "50.4613338%",
  id: "J"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100.047847%",
  y1: "50%",
  x2: "-5.43956161e-13%",
  y2: "50%",
  id: "K"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "-6.95757881e-13%",
  y2: "50%",
  id: "L"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.4366312%",
  y1: "49.6216788%",
  x2: "50.5590358%",
  y2: "50.4903413%",
  id: "M"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2D600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4D600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100.047847%",
  y1: "50%",
  x2: "6.79945202e-14%",
  y2: "50%",
  id: "N"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CDCF00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8A800",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "1.08100218e-14%",
  y1: "49.9981588%",
  x2: "100%",
  y2: "49.9981588%",
  id: "O"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0.0171969046%",
  y1: "49.9901452%",
  x2: "100%",
  y2: "49.9901452%",
  id: "P"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-0.056022409%",
  y1: "49.9912221%",
  x2: "100%",
  y2: "49.9912221%",
  id: "Q"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.0131337%",
  x2: "99.9885347%",
  y2: "50.0131337%",
  id: "R"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "49.9700334%",
  x2: "100%",
  y2: "49.9700334%",
  id: "S"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "21.6147309%",
  y1: "77.3728543%",
  x2: "81.2181303%",
  y2: "42.6576732%",
  id: "T"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50.0195389%",
  x2: "100%",
  y2: "50.0195389%",
  id: "U"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "V"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "50%",
  x2: "100%",
  y2: "50%",
  id: "W"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9B5C76",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#830051",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-252.000000, -432.000000) translate(252.000000, 432.000000)",
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#a)",
  cx: 753,
  cy: 195,
  rx: 245,
  ry: 195
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#b)",
  cx: 358.42,
  cy: 272.5,
  rx: 109.5,
  ry: 91.5
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "url(#c)",
  cx: 181,
  cy: 372,
  rx: 28,
  ry: 23
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 77.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#d)",
  opacity: 0.46,
  transform: "translate(238.924385, 108.994774) rotate(1.030000) translate(-238.924385, -108.994774)",
  x: 232.924385,
  y: 5.99477381,
  width: 12,
  height: 206
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#e)",
  opacity: 0.46,
  transform: "translate(234.426550, 108.913895) rotate(1.030000) translate(-234.426550, -108.913895)",
  x: 232.92655,
  y: 5.91389508,
  width: 3,
  height: 206
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.842 5.99h12v99a6 6 0 1 1-12 0v-99Z",
  fill: "url(#f)",
  opacity: 0.46,
  transform: "translate(239.842022, 58.489292) rotate(1.030000) translate(-239.842022, -58.489292)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.53 28.25c-.07 11.23-.75 32.3-1 43.06-.14 5.94-.5 23.75-.5 23.75S-.02 89 .25 72.8c.23-13.49.79-28.72 1-45A126.53 126.53 0 0 1 5.09.8s-.47 12.28-.56 27.45Z",
  opacity: 0.3,
  transform: "translate(239.000000, 87.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#g)",
  opacity: 0.46,
  transform: "translate(296.884531, 108.973528) rotate(6.100000) translate(-296.884531, -108.973528)",
  x: 290.884531,
  y: 26.4285285,
  width: 12,
  height: 165.09
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#h)",
  opacity: 0.46,
  points: "293.92 191 282.24 189.93 299.68 26.65 306.92 27 298.31 67.75 293.92 112 288.92 168 296.92 164"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#i)",
  opacity: 0.46,
  points: "302.67 111.63 296.79 106.21 290.74 110.35 299.62 27.22 311.55 28.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.92 27.64c-1.06 11.17-3.6 32.1-4.8 42.8-.67 5.9-2.61 23.61-2.61 23.61s-2.5-6.31-.8-22.42c1.42-13.41 3.33-28.54 5-44.73A126.84 126.84 0 0 1 11.92.31s-1.53 12.22-3 27.33Z",
  opacity: 0.3,
  transform: "translate(295.000000, 58.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#j)",
  opacity: 0.46,
  transform: "translate(859.886794, 109.010201) rotate(6.100000) translate(-859.886794, -109.010201)",
  x: 853.886794,
  y: 26.4652006,
  width: 12,
  height: 165.09
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#h)",
  opacity: 0.46,
  points: "856.92 191 845.24 189.93 862.68 26.65 869.92 27 861.31 67.75 856.92 112 851.92 168 859.92 164"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#i)",
  opacity: 0.46,
  points: "865.67 111.63 859.79 106.21 853.74 110.35 862.62 27.22 874.55 28.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.92 27.64c-1.06 11.17-3.6 32.1-4.8 42.8-.67 5.9-2.61 23.61-2.61 23.61s-2.5-6.31-.8-22.42c1.42-13.41 3.33-28.54 5-44.73A126.84 126.84 0 0 1 11.92.31s-1.53 12.22-3 27.33Z",
  opacity: 0.3,
  transform: "translate(858.000000, 58.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#k)",
  opacity: 0.46,
  transform: "translate(180.398708, 106.179735) rotate(-3.530000) translate(-180.398708, -106.179735)",
  x: 174.398708,
  y: 30.9047353,
  width: 12,
  height: 150.55
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#l)",
  opacity: 0.46,
  points: "190.68 180.36 178.98 181.24 169.77 31.77 176.97 30.94 175.07 68.92 177.9 109.37 182.02 160.48 190 167.28"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#m)",
  opacity: 0.46,
  points: "186.09 101.38 179.92 106 174.11 102.12 169.75 31.38 181.72 30.64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.97 27.79c.82 11.2 1.81 32.25 2.41 43 .33 5.93 1.38 23.71 1.38 23.71s-3.52-5.79-4.53-22C2.38 59.03 1.74 43.8.67 27.56A125.83 125.83 0 0 1 2.35.31s.5 12.35 1.62 27.48Z",
  opacity: 0.3,
  transform: "translate(181.000000, 84.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#n)",
  opacity: 0.46,
  points: "462.63 52.52 452.81 51.6 451.54 48.96 466.55 3.42 477.96 7.12"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#o)",
  opacity: 0.46,
  points: "452.81 51.6 451.54 48.96 466.89 3.53 469.4 4.34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.42 18.42c-1.4 4.58-6.5 20.94-6.5 20.94l-4-.37s5.47-15.53 7.47-21.85C11.14 8.48 17.2.79 17.2.79s-2.8 7.83-5.78 17.63Z",
  opacity: 0.3,
  transform: "translate(456.000000, 13.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#p)",
  opacity: 0.46,
  points: "422.59 253.03 426.92 251 432.7 251.43 434.29 252.95 425.79 253.01"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#q)",
  opacity: 0.46,
  points: "435.09 287.92 425.55 289.93 423.45 288.42 422.63 253.03 434.33 252.95"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#r)",
  opacity: 0.46,
  points: "425.55 289.93 423.45 288.41 422.63 253.03 425.79 253.01"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.78 19.18c.16 2.78.85 15.05.85 15.05L.92 35S.63 22.79.45 19C.01 9.93 3.02.61 3.02.61s.14 8.39.76 18.57Z",
  opacity: 0.3,
  transform: "translate(429.000000, 254.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#s)",
  opacity: 0.46,
  points: "528.04 188.91 509.36 137.54 502.88 136.26 508.61 132.5 514.54 133.43"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#t)",
  opacity: 0.46,
  points: "528.04 188.91 516.38 191.75 502.88 136.26 509.36 137.54 514.54 133.43"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#u)",
  opacity: 0.46,
  points: "527.72 188.76 516.34 191.59 502.92 136.41 509.36 137.54 509.19 149.48 513.15 164.35 518.69 183.01 525.61 179.61"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2.84 0.59 7.92 15.81 0.36 2.54",
  opacity: 0.3,
  transform: "translate(509.000000, 135.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#v)",
  opacity: 0.46,
  points: "404.92 112.07 387.81 33.18 399.54 30.64 416.59 109.29 409.92 113"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#w)",
  opacity: 0.46,
  points: "326.48 232.92 357.86 204.73 359.86 210.99 365.88 213.66 334.48 241.87 334.42 241.84 332.83 235.76"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#w)",
  opacity: 0.46,
  points: "326.48 232.92 357.86 204.73 359.86 210.99 365.88 213.66 334.48 241.87 334.42 241.84 332.83 235.76"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#x)",
  opacity: 0.46,
  points: "326.48 232.92 357.75 204.83 359.8 211.04 349.2 216.54 337.99 227.07 330.34 234.66"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#y)",
  opacity: 0.46,
  points: "333.94 240.01 359.8 211.04 357.86 204.73 363.89 207.99 365.88 213.66 334.35 241.31"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#z)",
  opacity: 0.46,
  points: "328.9 239 326.48 232.95 332.83 235.76 334.42 241.84"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "16.7 1.3 0.52 18.53 13.8 0.04",
  opacity: 0.3,
  transform: "translate(346.000000, 211.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#A)",
  opacity: 0.46,
  points: "416.59 109.29 411.92 108 404.92 112.07 387.84 33.33 394.87 31.59 395.06 52.46 400.04 73.83 406.87 100.73 415.07 102.97 415.7 105.23"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2.92 25 0.25 0.42 6.65 26.03",
  opacity: 0.3,
  transform: "translate(409.000000, 83.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#B)",
  opacity: 0.46,
  points: "567.97 223.07 562.9 199.69 568.92 197 574.65 197.26 579.64 220.29 572.97 224"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#C)",
  opacity: 0.46,
  points: "579.64 220.29 574.97 219 567.97 223.07 562.9 199.69 566.24 198.2 569.92 211.73 578.12 213.97 578.75 216.23"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "1.97 19 0.92 0 5.7 20.03",
  opacity: 0.3,
  transform: "translate(573.000000, 200.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#D)",
  opacity: 0.46,
  transform: "translate(694.510000, 106.998600) rotate(-178.854237) translate(-694.510000, -106.998600)",
  x: 688.5088,
  y: 3.97800206,
  width: 12.0023998,
  height: 206.041196
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#E)",
  opacity: 0.46,
  transform: "translate(697.971230, 109.103032) rotate(-178.970000) translate(-697.971230, -109.103032)",
  x: 696.47123,
  y: 6.10303212,
  width: 3,
  height: 206
}), /*#__PURE__*/React.createElement("path", {
  d: "M686.567 106.998h12v99a6 6 0 1 1-12 0v-99Z",
  fill: "url(#F)",
  opacity: 0.46,
  transform: "translate(692.566702, 159.498429) rotate(-178.970000) translate(-692.566702, -159.498429)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.92 67.75c.06-11.23.75-32.3 1-43.06.14-5.94.51-23.75.51-23.75S5.43 7 5.21 23.2c-.23 13.49-.8 28.72-1 45a126.53 126.53 0 0 1-3.84 27s.41-12.28.55-27.45Z",
  opacity: 0.3,
  transform: "translate(688.000000, 35.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#G)",
  opacity: 0.46,
  transform: "translate(635.524047, 109.001393) rotate(-173.900000) translate(-635.524047, -109.001393)",
  x: 629.524047,
  y: 26.456393,
  width: 12,
  height: 165.09
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#H)",
  opacity: 0.46,
  points: "638.49 27 650.16 28.07 632.73 191.35 625.49 191 634.1 150.25 638.49 106 643.49 50 635.49 54"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#I)",
  opacity: 0.46,
  points: "629.73 106.37 635.62 111.79 641.66 107.65 632.78 190.78 620.85 189.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.45 67.36c1.06-11.17 3.6-32.1 4.8-42.8.67-5.9 2.61-23.61 2.61-23.61s2.5 6.31.8 22.42c-1.42 13.41-3.33 28.54-5 44.73A126.84 126.84 0 0 1 .45 94.69s1.57-12.22 3-27.33Z",
  opacity: 0.3,
  transform: "translate(625.000000, 65.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#J)",
  opacity: 0.46,
  transform: "translate(752.001740, 111.859252) rotate(176.470000) translate(-752.001740, -111.859252)",
  x: 746.00174,
  y: 36.5842518,
  width: 12,
  height: 150.55
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#K)",
  opacity: 0.46,
  points: "741.73 37.64 753.42 36.76 762.63 186.23 755.43 187.06 757.34 149.08 754.51 108.63 750.38 57.52 742.41 50.72"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#L)",
  opacity: 0.46,
  points: "746.32 116.62 752.49 112 758.3 115.88 762.66 186.62 750.68 187.36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.44 67.21c-.82-11.2-1.81-32.25-2.42-43C1.69 18.28.65.5.65.5s3.52 5.79 4.53 22c.85 13.47 1.49 28.7 2.56 44.94a126.56 126.56 0 0 1-1.68 27.25s-.5-12.35-1.62-27.48Z",
  opacity: 0.3,
  transform: "translate(743.000000, 39.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "url(#M)",
  opacity: 0.46,
  transform: "translate(74.997266, 111.815581) rotate(176.470000) translate(-74.997266, -111.815581)",
  x: 68.997266,
  y: 36.5405811,
  width: 12,
  height: 150.55
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#N)",
  opacity: 0.46,
  points: "64.73 37.64 76.42 36.76 85.63 186.23 78.44 187.06 80.34 149.08 77.51 108.63 73.38 57.52 65.41 50.72"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#L)",
  opacity: 0.46,
  points: "69.32 116.62 75.49 112 81.3 115.88 85.66 186.62 73.68 187.36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.44 67.21c-.82-11.2-1.81-32.25-2.42-43C1.69 18.28.65.5.65.5s3.52 5.79 4.53 22c.85 13.47 1.49 28.7 2.56 44.94a126.56 126.56 0 0 1-1.68 27.25s-.5-12.35-1.62-27.48Z",
  opacity: 0.3,
  transform: "translate(66.000000, 39.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.92 0c-38.72.89-71.19 22.95-94.56 54 0 0-45.44 69-87.44 121C39.09 200.79 12.79 210 0 214.21c45 9.4 88.15-15.82 115.57-52C136.92 134 159.92 94 190.92 54c24.78-32 57.73-47.35 72-52a125.28 125.28 0 0 0-21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 0c38.72.89 71.19 22.95 94.57 54 0 0 45.43 69 87.43 121 20.84 25.79 47.14 35 59.92 39.21-45 9.4-88.14-15.82-115.56-52C126 134 103 94 72 54 47.22 22 14.28 6.65 0 2a125.28 125.28 0 0 1 21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465.92 0c-38.72.89-71.19 22.95-94.56 54 0 0-45.44 69-87.44 121-20.83 25.79-47.13 35-59.92 39.21 45 9.4 88.15-15.82 115.57-52C360.92 134 383.92 94 414.92 54c24.78-32 57.73-47.35 72-52a125.28 125.28 0 0 0-21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M689.92 0c-38.72.89-71.19 22.95-94.56 54 0 0-45.44 69-87.44 121-20.83 25.79-47.13 35-59.92 39.21 45 9.4 88.15-15.82 115.57-52C584.92 134 607.92 94 638.92 54c24.78-32 57.73-47.35 72-52a125.28 125.28 0 0 0-21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M914.92 0c-38.72.89-71.19 22.95-94.56 54 0 0-45.44 69-87.44 121-20.83 25.79-47.13 35-59.92 39.21 45 9.4 88.15-15.82 115.57-52C809.92 134 832.92 94 863.92 54c24.78-32 57.73-47.35 72-52a125.28 125.28 0 0 0-21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694 0c38.72.89 71.19 22.95 94.57 54 0 0 45.43 69 87.43 121 20.84 25.79 47.14 35 59.92 39.21-45 9.4-88.14-15.82-115.56-52C799 134 776 94 745 54c-24.78-32-57.72-47.35-72-52a125.28 125.28 0 0 1 21-2Z",
  fill: "url(#O)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.92 34c-12.59 17.77-35.26 51.75-47 69-6.48 9.52-26 38-26 38s12-6 29.86-31.84C45.65 87.65 61.92 63 79.92 37.1a251.13 251.13 0 0 1 32-37.1s-21 10-38 34Z",
  opacity: 0.3,
  transform: "translate(94.000000, 30.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.92 34c-12.59 17.77-35.26 51.75-47 69-6.48 9.52-26 38-26 38s12-6 29.86-31.84C45.65 87.65 61.92 63 79.92 37.1a251.13 251.13 0 0 1 32-37.1s-21 10-38 34Z",
  opacity: 0.3,
  transform: "translate(318.000000, 30.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.92 34c-12.59 17.77-35.26 51.75-47 69-6.48 9.52-26 38-26 38s12-6 29.86-31.84C45.65 87.65 61.92 63 79.92 37.1a251.13 251.13 0 0 1 32-37.1s-21 10-38 34Z",
  opacity: 0.3,
  transform: "translate(542.000000, 30.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.92 34c-12.59 17.77-35.26 51.75-47 69-6.48 9.52-26 38-26 38s12-6 29.86-31.84C45.65 87.65 61.92 63 79.92 37.1a251.13 251.13 0 0 1 32-37.1s-21 10-38 34Z",
  opacity: 0.3,
  transform: "translate(765.000000, 30.000000)",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "m372.92 148 9.5 1.5 2-14 14 11s-6.5-15.5-11.88-24.77c-26.32-36.36-47-67.71-47-67.71-23.38-31.07-55.85-53.13-94.57-54a125.28 125.28 0 0 0-21 2c14.28 4.65 47.22 20 72 52 27.06 34.92 48 69.83 67.12 96.89.354.459.731.9 1.13 1.32l8.7-4.23Z",
  fill: "url(#P)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.92 214.21c-12.78-4.16-39.08-13.42-59.92-39.21-2.23-2.77-6.43-8.07-7.47-9.38-.15-.19-1.61-1.62-1.61-1.62l.26 7.28-11.76 2.22 3 11.19-11.75-8.94s6.3 13.25 9.9 20.88c23.35 15.67 51 23.51 79.35 17.58Z",
  fill: "url(#Q)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m562.92 68-10.42-1.31-2 14-14-11s7.42 15.31 11.88 24.77c26.33 36.36 47 67.71 47 67.71 23.37 31.07 55.84 53.13 94.56 54a125.28 125.28 0 0 0 21-2c-14.27-4.65-47.22-20-72-52-27.53-35.52-48.74-71-68.1-98.28-3.92 2.11-7.92 4.11-7.92 4.11Z",
  fill: "url(#R)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M448 2c12.79 4.16 39.09 13.42 59.92 39.21 2.56 3.17 7 8.81 7 8.81l1.83-5.09 11.75-2.22-2.94-11.19 11.74 8.94s-6.38-14.46-9.9-20.91C503.98 3.89 476.35-3.95 448 2Z",
  fill: "url(#S)"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#T)",
  points: "364.25 152.21 363.12 150.89 372.71 145.9 380.3 147.59 383.02 131.85 396.76 142.65 398.42 146.5 385.82 139.15 383.53 152.41 373.13 150.1"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#U)",
  points: "411.99 189.59 399.09 178.85 397.38 175.55 406.85 181.41 404.57 172.29 416.83 170.24 417.92 164 419.53 165.62 420 172.76 408.27 174.71"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#V)",
  points: "514.92 50 514.15 49 515.11 43.2 526.59 41.28 523.51 28.35 533.48 35.73 527.38 19.52 530.98 23.5 541.35 45.27 528.33 35.65 530.25 43.72 517.72 45.8"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "url(#W)",
  points: "530.32 61.96 549.43 77.25 551.21 64.82 562.54 65.95 570.02 62.21 571.01 64.18 563.29 70.05 554.63 69.18 552.4 84.75 541.51 76.04 549.72 93.13 548.12 93.9"
})))));

export default Svg404;